



















































































































































import {
  checklistPostReq
} from "@/services/checklist.service";

import MachinesGroupModal from "@/components/MachinesGroupModal.vue";
import draggable from "vuedraggable";


// machinegroups-overview
export default {
  data() {
    return {
      na1: false,
      initLoaded: false,
      create_dialog: false,
      create_progress: false, 
      create_error: false, 
      delete_dialog: false, 
      delete_item: {}, 
      delete_progress: false,
      export_dialog: false,
      showTransferInspect: false, 
      cl_item: null,

      //----

      showMachines: false, 
      group_machines: [],
      group_uid: null,
      create_name: "", 
      update_uid: null,
      delete_uid: null, 
      company_id: true, 
    };
  },
  components: {
    MachinesGroupModal,
    draggable,
  },

  mounted() {
    this.$store.state.headerTitle = this.$t('NAVI.MACHINES_GROUPS_COMPANY')

    //var db = new PouchDB('dbname');
    checklistPostReq('machinegroups-overview', { companyId:  this.$store.getters.companyId, only_intern: true }) 
      .then(resp => {
        if (resp.status == "success") {
          this.$store.state.machines_group_list = resp.data.list
          this.$store.state.machines = resp.data.machines;
          this.initLoaded = true
        }
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
    }); 
    
  },
  computed: {
    items: {
      get: function () {
        return this.$store.state.machines_group_list; 
      },
      // setter
      set: function (newValue) {
        this.$store.state.machines_group_list = newValue
        checklistPostReq('machinegroups-sort', { list: newValue }) 
          .then(resp => {
            if (resp.status == "success") {
            
            }
          })
          .catch(e => {
            this.$store.dispatch("api_error", e);
        });
      }
      //return this.$store.state.machines_group_list; 
    }
  },
  methods: {
    exportXls() {

      let csv_data = 'name;id;machines;\n'

      for (let item of this.items) {

        console.log(item)
        csv_data += item["name"]+";"+item["uid"]+";"+item["machines"].length+";\n";
      
      }
      var csvData = new Blob(["\uFEFF" + csv_data], {
              type: "text/csv;charset=windows-1252",
            });
            var csvURL = null;
            if (navigator.msSaveBlob) {
              csvURL = navigator.msSaveBlob(csvData, "download.csv");
            } else {
              csvURL = window.URL.createObjectURL(csvData);
            }
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute(
              "download",
              new Date().getFullYear() +
                "_" +
                (new Date().getMonth() + 1) +
                "_" +
                new Date().getDate() +
                "_machines_groups.csv"
            );
            tempLink.click();


    },
    openGroup(item) {
      this.company_id = this.$store.getters.companyId
      this.group_uid = item.uid
      this.group_machines = JSON.parse(JSON.stringify(item.machines)) 
      this.showMachines = true
    },

    dialogClosed() {
      this.showMachines = false
    },

    updateGroup(item) {
      this.create_name = item.name
      this.update_uid = item.uid
      this.create_dialog = true
    },
    duplicateGroup(item) {
      checklistPostReq('machinegroups-duplicate', { uid: item.uid, companyId: this.$store.getters.companyId }) 
        .then(resp => {
          if (resp.status == "success") {
            console.log("hallo", resp)
            this.$store.state.machines_group_list = resp.data.list
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
      });      
    },
    newGroup() {
      this.create_name = ""
      this.update_uid = null
      this.create_dialog = true
    },
    deleteGroup(item) {
      this.delete_uid = item.uid
      this.delete_dialog = true
      this.delete_item = item
    },
   
    deleteGroupAction() {
      this.delete_progress = true
      checklistPostReq('machinegroups-remove', { uid: this.delete_uid, companyId: this.$store.getters.companyId }) 
        .then(resp => {
          if (resp.status == "success") {
            this.$store.state.machines_group_list = resp.data.list
            this.delete_dialog = false
            this.delete_progress = false
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
      });


    },
    saveNewGroup() {
      this.create_error = !this.create_name || this.create_name.length <= 1;

      if (this.create_name  && this.create_name.length > 1) {
        this.create_progress = true;

        checklistPostReq('machinegroups-create', { companyId: this.$store.getters.companyId, name: this.create_name, update_uid: this.update_uid }) 
          .then(resp => {
            if (resp.status == "success") {
               this.create_progress = false
              this.$store.state.machines_group_list = resp.data.list
              this.create_dialog = false
            }
          })
          .catch(e => {
            this.$store.dispatch("api_error", e);
        });

      }
    }
  }
};
